<template>
    <div class="container">
        <div class="video-wrapper w-100" v-if="video_id != null && video_id != ''">
            <div ref="plyr" class="plyr__video-embed" id="full-width-player">
                <iframe :src="`https://player.vimeo.com/video/${video_id}?loop=true&amp;autopause=false&amp;width=1024&amp;controls=false&amp;transparent=false&amp;gesture=media&amp;dnt=true`" allowfullscreen allowtransparency allow="autoplay"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import Plyr from 'plyr';

export default {
    props: {
        video_id: {
            type: [String, Number],
            required: true
        }
    },

    data: (vm) => ({
        videoPlayer: null
    }),

    mounted() {
        if (this.video_id != null && this.video_id != '' && !this.isInternetExplorer()) {
            var self = this;
            setTimeout(function () {
                self.loaded = true;
                self.videoPlayer = new Plyr("#full-width-player", {
                    muted: true,
                    hideControls: false,
                    disableContextMenu: false,
                    autoplay: false,
                    controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'airplay', 'fullscreen']
                });
            }, 2000);
        }
    },

    methods: {
        isInternetExplorer() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {
                return true;
            }
            else  // If another browser, return 0
            {
                return false;
            }
        }
    },
}
</script>

